module.exports = require("pino");


//////////////////
// WEBPACK FOOTER
// external "pino"
// module id = 19
// module chunks = 0